import Vue from 'vue'

import withRender from './ratings-breakdown.html'
import './ratings-breakdown.scss'

const MIN_REVIEWS_FOR_FILTERING = 3

export default withRender((Vue as any).extend({
  props: {
    headingLevel: { type: Number, default: 3 },
    ratingsBreakdown: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    breakdownForDisplay() {
      return this.ratingsBreakdown.sort((a, b) => b.rating - a.rating)
        .map((item) => {
          const percentage = (item.num / this.total)
          // only going to apply a filter if this item has reviews and the overall total is
          // at least 3
          const isFilterable = this.total >= MIN_REVIEWS_FOR_FILTERING && item.num > 0
          return {
            isFilterable,
            num: item.num,
            progressWidth: `${(percentage * 100).toFixed(1)}%`,
            pctOfRatingsFormatted: item.pctOfRatingsFormatted,
            rating: item.rating
          }
        })
    },
    total() {
      return this.ratingsBreakdown.reduce((acc, curr) => acc + curr.num, 0)
    }
  },
  methods: {
    ratingSelected(ratingData) {
      if (!ratingData || !ratingData.isFilterable) {
        return
      }
      this.$emit('setFilter', 'cm', 'rt', ratingData.rating)
    }
  }
}))
